import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import AgentsListPage from 'features/agents/pages/AgentsListPage';
import WorkflowEditorPage from 'features/agents/WorkflowEditor/WorkflowEditorPage';
import ExecutionsPage from 'features/agents/pages/ExecutionsPage';

/**
 * AgentsPage — sub-router for `/:team/agents/*`. App.js mounts a single splat
 * route; this component reads the trailing segments and picks the panel.
 *
 *   /:team/agents                            → AgentsListPage
 *   /:team/agents/:workflowId                → WorkflowEditorPage
 *   /:team/agents/:workflowId/executions     → ExecutionsPage
 */
export default function AgentsPage() {
  const { team } = useParams();
  const { pathname } = useLocation();
  const base = `/${encodeURIComponent(team)}/agents`;
  const after = pathname.startsWith(base) ? pathname.slice(base.length).replace(/^\/+/, '').replace(/\/+$/, '') : '';
  const parts = after ? after.split('/') : [];

  if (parts.length === 0) return <AgentsListPage />;
  // The Credentials page is gone (connections live in Settings → Integrations
  // and inside each agent); old links land on the list.
  if (parts[0] === 'credentials') return <Navigate to={base} replace />;

  // workflowId in slot 0
  const workflowId = parts[0];
  if (parts[1] === 'executions') return <ExecutionsPage workflowId={workflowId} />;
  return <WorkflowEditorPage workflowIdOverride={workflowId} />;
}
